import { useEffect } from 'react'

export const SBMBundle = 'atc-edge.studybreakmedia.com/bundles'
export const windowReload = () => window.location.reload()

/**
 * When navigating to an Auth page, we must make sure there are no ads
 * We check to see if the SBM script has been apended to the head.
 * If so, we force a reload of the page. There is no Next.js was
 * of forcing a full page reload
 */
const useSBMCheck = () => {
  useEffect(() => {
    const scripts = document.getElementsByTagName('script')
    const SBMScript = Array.from(scripts).find((script) => script.src.includes(SBMBundle))

    if (SBMScript) {
      windowReload()
    }
  }, [])
}

export default useSBMCheck
